import script from "./MinimalIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MinimalIcon.vue?vue&type=script&setup=true&lang=js"

import "./MinimalIcon.vue?vue&type=style&index=0&id=652422e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652422e2"]])

export default __exports__